export const parsePostCodeForTagging = (postcode: string) => {
  const length = postcode.length;
  return postcode.substring(0, length - 3).replace(/ /g, '');
};
